module.exports = __webpack_public_path__ + "static/media/gozaresh-amari.9535b4a0.png";